/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

import * as React from 'react';
import { IldsFooterProps } from '../lds-footer.data';
// @ts-ignore
import { Text5 } from '@churchofjesuschrist/eden-text';
import { format } from '@msdyn365-commerce-modules/utilities';

const CopyRight: React.FC<IldsFooterProps> = ({ resources }) => {
    const currentDate = new Date();

    const currentYear = currentDate.getFullYear();

    const currentYearString = currentYear.toString();

    const copyRightText = format(resources.copyRight, currentYearString);

    return (
        <div className='CopyRight'>
            <div className='footerTest'>
                <p>{copyRightText}</p>
            </div>
            <div className='AllRightsReserved'>
                <p>{resources.allRightsReserved}</p>
            </div>
        </div>
    );
};

export default CopyRight;
